// extracted by mini-css-extract-plugin
export var infoItem = "_tk-2";
export var title = "_tk-0";
export var value = "_tk-1";